import { Grid, OutlinedInput } from '@material-ui/core'
import {
  default as Button,
  default as SubmitButton,
} from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import Popup from 'Components/Popup'
import { SnackBarContext } from 'Components/SnackBar'
import { authorization } from 'Module/Auth/Auth'
import React, { useContext, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { getClientEmails } from '../../../gql/getClientEmails'
import { sendEmail } from '../../../gql/sendEmail'
import styles from './styles'

const EmailPopup = ({ classes, onCancel, isOpen }) => {
  const { campaignId } = useParams()
  const [isInProgress, setIsInProgress] = useState(false)
  const [validationError, setValidationError] = useState(false)
  const [userEmails, setUserEmails] = useState([])
  const campaign = useSelector(state => state.campaigns.campaigns[campaignId])
  const runSnackBar = useContext(SnackBarContext)

  useGraphQLFetch({
    fetchFn: getClientEmails,
    defaultFetchArgs: {
      clientId: campaign.client.id,
    },
    mapResponse: data => {
      const emails = data.getUsers.map(user => user.email)
      setUserEmails(emails)
    },
    skipFetchOnInit: false,
  })
  const [subject, setSubject] = useState(
    'There is an issue with your submitted codes',
  )
  const user = authorization.getUser()
  const text = useRef(null)

  const onSendEmail = async () => {
    const response = await sendEmail({
      input: {
        isHtml: true,
        sender: user.email,
        recipients: userEmails,
        subject: subject,
        body: `<div>${text.current.value
          .split(/\r\n|\r|\n|[.|!|?]\s/gi)
          .map(el => `<p>${el}</p>`)
          .join('')}</div>`,
      },
    })
    await response.json()
    runSnackBar({
      type: 'success',
      msg: `Emails successfully sent.`,
    })
    onCancel()
    setIsInProgress(false)
  }

  const validator = () => {
    setValidationError()
    if (text.current.value.length >= 2000) {
      setValidationError('Message should be shorter than 2000 characters')
    }
    if (text.current.value.length <= 30) {
      setValidationError('Message should be longer than 30 characters')
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <Popup
      title="We're here to help!"
      onCancel={onCancel}
      canBeClose={!isInProgress}
      modalClassName={classes.submissionPopup}
      body={
        <div className={classes.body}>
          <span className={cn(classes.boldText)}>Send decline email</span>
          <Grid
            container
            xs={12}
            direction="column"
            className={classes.inputContainer}
          >
            <Grid className={classes.rowContainer}>
              <span className={classes.inputName}>From:</span>
              <OutlinedInput value={user.email} style={styles.input} disabled />
            </Grid>
            <Grid className={classes.rowContainer}>
              <span className={classes.inputName}>To:</span>
              <OutlinedInput
                placeholder="Separate recipients with a “,” and leave empty if N/A"
                value={userEmails.join(', ')}
                style={styles.input}
                disabled
              />
            </Grid>
            <Grid className={classes.rowContainer}>
              <span className={classes.inputName}>Subject:</span>
              <OutlinedInput
                id={'subjectInput'}
                value={subject}
                style={styles.input}
                onChange={e => setSubject(e.target.value)}
                error={!subject.length}
              />
            </Grid>
          </Grid>
          <Grid container xs={12} className={classes.rowContainer}>
            <textarea
              className={classes.textArea}
              rows="10"
              ref={text}
              placeholder="Your message here..."
              defaultValue={`Hi.

We have reviewed the codes submitted for campaign ${campaign.name}.
              
Unfortunately, we'll have to ask you to resubmit the data for the following reasons: 

* Specify reason(s) here

Please reach out if you have any questions about this.

Regards, ${user.firstName}`}
              onChange={validator}
            />
          </Grid>
          {validationError ? (
            <div className={classes.error}>{validationError}</div>
          ) : null}
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ paddingTop: '10px' }}
            xs={12}
          >
            <Grid container xs justifyContent="flex-end">
              <Button
                variant="text"
                onClick={onCancel}
                style={{ marginRight: '16px' }}
                className={classes.button}
              >
                Cancel
              </Button>
              <SubmitButton
                className={classes.submitButton}
                onClick={onSendEmail}
                disabled={validationError || !subject.length}
              >
                Send
              </SubmitButton>
            </Grid>
          </Grid>
        </div>
      }
    />
  )
}

export default withStyles(styles)(EmailPopup)
